export default {
	methods: {
		//选中
		selectionChange(val) {
			this.selectionShopArr = val;
		},
		//编辑商品机制
		editProductFun(row, tabName) {
			this.$refs.editProduct.initEditFun(row, tabName);
		},
		//合作数据
		cooperFun(row, tabName) {
			this.$refs.cooperData.initCooperFun(row, tabName);
		},
		//更改商品链接
		replaceLinkFun(row, tabName, title) {
			this.$refs.replaceLink.initLinkFun(row, tabName, title);
		},
		//拒绝带货
		refuseFun(row) {
			this.$refs.refuse.initrefuseFun(row);
		},
		//拒绝带发货原因
		reasonFun(row, state, tabName) {
			this.$refs.reason.initReasonFun(row, state, tabName);
		},
		//申请样品
		applyFun(row, tabName) {
			this.$refs.apply.initApplyFun(row, tabName);
		},
		//变更详情 //前端
		changeFun(row, tabName) {
			this.$refs.change.initChange(row, tabName);
		},
		//查看变更详情  //回写
		changeDFun(row, tabName) {
			this.$refs.changeDetails.initCDhange(row, tabName);
		},
		//多功能弹框
		multiFun(row, state, tabName, platform_id) {
			this.$refs.multi.initMulti(row, state, tabName, platform_id);
		},
		//确认开播, 确认带货
		beginFun(row, state, tabName) {
			this.$refs.begin.initBeginFun(row, state, tabName);
		},
		// 审核交付内容, 查看交付内容, 查看拒绝原因
		deliverFun(row, state, tabName) {
			this.$refs.deliver.initDeliverFun(row, state, tabName);
		},
		//查看详情
		detailsFun(row, tabName) {
			const routeLink = this.$router.resolve({
				path: '/cooperationProgress/details',
				query: {
					cooperate_id: row.cooperate_id,
					tabName: tabName,
				},
			});
			window.open(routeLink.href, '_blank');
		},
		//查看手卡
		lookCard(row, state) {
			this.$refs.handCardDialog.seeHandCard(row);
		},
		//查看短视频效果
		lookVide(row) {
			this.$refs.shortVideo.show(row);
		},
		//详情按钮

		//是否移出选品表
		isRemove(row) {
			if (this.$auth.hasPermi('system:cooperationProgress:selection:Remove') && this.tabName == '0') {
				return true;
			} else {
				return false;
			}
		},
		//是否查看手卡
		isLookCard(row) {
			if (row && row?.hand_card) {
				return true;
			} else {
				return false;
			}
		},
		//是否申请样品
		isApply(row) {
			if (
				this.$auth.hasPermi('system:cooperationProgress:selection:Apply') &&
				this.tabName == '0' &&
				row?.is_change != this.changeStatus.yes &&
				row?.product_status === this.productStatus.up &&
				row?.promote_status != this.promoteStatus.close
			) {
				return true;
			} else {
				return false;
			}
		},
		//是否查看变更机制
		isChange(row) {
			if (row.is_change == this.changeStatus.yes && (this.tabName == '0' || this.tabName == '1')) {
				return true;
			} else {
				return false;
			}
		},
		//是否删除待播表
		isDel(row) {
			if (
				this.$auth.hasPermi('system:cooperationProgess:Waiting-del-goods') &&
				this.tabName == '2' &&
				(row?.product_status === this.productStatus.down || row?.promote_status == this.promoteStatus.close)
			) {
				return true;
			} else {
				return false;
			}
		},
		//是否删除申样表
		isDelete(row) {
			if (
				this.$auth.hasPermi('system:sampleOrder:ClosedSample') &&
				this.tabName == '1' &&
				(row?.product_status === this.productStatus.down ||
					row?.promote_status == this.promoteStatus.close ||
					row?.delivery_info?.is_affirm == this.affirmStatus.refuse ||
					row?.delivery_info?.is_refuse_delivery == this.refuseDelivery.yes)
			) {
				return true;
			} else {
				return false;
			}
		},
		//是否拒绝带货
		isRefuse(row) {
			if (
				this.$auth.hasPermi('system:sampleOrder:RefuseTakeGoods') &&
				this.tabName == '1' &&
				row?.promote_status === this.promoteStatus.open &&
				row?.product_status === this.productStatus.up &&
				row?.delivery_info.delivery_status == this.deliveryStatus.arrived &&
				row?.delivery_info?.is_affirm != this.affirmStatus.refuse
			) {
				return true;
			} else {
				return false;
			}
		},
		//是否确认带货
		isOkGoods(row) {
			if (
				this.$auth.hasPermi('system:sampleOrder:Confirm-shipmentation') &&
				this.tabName == '1' &&
				row?.promote_status === this.promoteStatus.open &&
				row?.product_status === this.productStatus.up &&
				row?.delivery_info.delivery_status == this.deliveryStatus.arrived &&
				row?.delivery_info?.is_affirm != this.affirmStatus.refuse
			) {
				return true;
			} else {
				return false;
			}
		},
		//是否校验链接
		isCheck(row) {
			if (
				this.$auth.hasPermi('system:cooperationProgress:Waiting-verify') &&
				this.tabName == '2' &&
				row?.live_info.url_check_status == this.linkStatus.tobeCheck
			) {
				return true;
			} else {
				return false;
			}
		},
		//是否确认开播
		isBegin(row) {
			if (
				this.$auth.hasPermi('system:cooperationProgress:Confirmed-broadcasting') &&
				this.tabName == '2' &&
				row?.live_info.url_check_status == this.linkStatus.finished &&
				row?.cooperate_status == '3'
			) {
				return true;
			} else {
				return false;
			}
		},
		//是否结束合作
		isEnd(row) {
			if (
				this.$auth.hasPermi('system:cooperationProgress:broadcast-finish') &&
				this.tabName == '3' &&
				row?.live_info?.cooperate_status != this.cooperationStatus.end
			) {
				return true;
			} else {
				return false;
			}
		},
		//修改商品机制
		isEdit(row) {
			if (
				this.$auth.hasPermi('system:cooperationProgress:edit-goods') &&
				(this.tabName == '0' || this.tabName == '1') &&
				row?.product_status === this.productStatus.up &&
				row?.promote_status != this.promoteStatus.close
			) {
				return true;
			} else {
				return false;
			}
		},
		//发货
		isSend(row) {
			if (
				this.$auth.hasPermi('system:sampleOrder:deliver') &&
				this.tabName == '1' &&
				row?.delivery_info.delivery_status == this.deliveryStatus.notShipped &&
				row?.delivery_info?.is_refuse_delivery == this.refuseDelivery.no
			) {
				return true;
			} else {
				return false;
			}
		},
		//上传链接
		isUpload(row) {
			if (
				this.$auth.hasPermi('system:cooperationProgress:upload-link') &&
				this.tabName == '2' &&
				row?.live_info?.url_check_status == this.linkStatus.toboUp
			) {
				return true;
			} else {
				return false;
			}
		},
		//更换链接
		isReplace(row) {
			if (
				this.$auth.hasPermi('system:cooperationProgress:Waiting-switch') &&
				this.tabName == '2' &&
				row?.live_info?.url_check_status === this.linkStatus.tobeCheck
			) {
				return true;
			} else {
				return false;
			}
		},
		//查看关联样品订单
		viewSampleOrder(row) {
			const routeLink = this.$router.resolve({
				path: '/sample/list',
				query: {
					cooperate_id: row.cooperate_id,
				},
			});
			window.open(routeLink.href, '_blank');
		},
	},
};
